import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cascader from 'antd/lib/cascader';

interface BreadcrumbOption {
    value: string;
    label: string;
    children?: BreadcrumbOption[];
}

export const CaisoBreadcrumbNav = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [selectedValue, setSelectedValue] = useState<string[]>([]);

    const breadcrumbOptions: BreadcrumbOption[] = [
        {
            value: 'caiso',
            label: 'CAISO',
            children: [
                {
                    value: 'sibr',
                    label: 'SIBR',
                    children: [
                        { value: 'overview', label: 'Overview' },
                        { value: 'configuration', label: 'Configuration' },
                    ],
                },
                {
                    value: 'drrs',
                    label: 'DRRS',
                    children: [
                        { value: 'locations', label: 'Locations' },
                        { value: 'registrations', label: 'Registrations' },
                    ],
                },
                {
                    value: 'cmri',
                    label: 'CMRI',
                    children: [{ value: 'overview', label: 'Overview' }],
                },
            ],
        },
    ];

    useEffect(() => {
        const pathParts = pathname.split('/').filter(part => part);
        setSelectedValue(pathParts);
    }, [pathname]);

    const handleBreadcrumbChange = (value: string[]) => {
        const [view, subView, subView2] = value;

        let path = `/${view}`;
        if (subView) {
            path += `/${subView}`;
        }
        if (subView2) {
            path += `/${subView2}`;
        }

        navigate(path);
    };

    return (
        <div>
            <Cascader
                options={breadcrumbOptions}
                onChange={handleBreadcrumbChange}
                value={selectedValue}
                placeholder="Select navigation"
                style={{ width: '300px' }}
                size="large"
                allowClear={false}
            />
        </div>
    );
};
